import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IdCardIcon extends BaseIcon {
  getChildren = () => {
  const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()
    return [ <>
      <path
          d="M15,14H1a.945.945,0,0,1-1-1V4A.945.945,0,0,1,1,3H15a.945.945,0,0,1,1,1v9A.945.945,0,0,1,15,14ZM8,4H1v9H8ZM9,9h5V8H9Zm6-3H9V7h6Z"
          transform="translate(0 -3)" fill={color} fillRule="evenodd"/>
      <path
          d="M1.9,11.7c-.2.1-.5.2-.7.3H7.7a4.875,4.875,0,0,0-.7-.3c-1.2-.4-1.6-.8-1.6-1.6,0-.5.4-.3.5-1.2.1-.4.4,0,.5-.9a.433.433,0,0,0-.2-.4,5.527,5.527,0,0,0,.1-.9C6.5,6.3,6.1,5,4.5,5a1.812,1.812,0,0,0-2,1.7,4.126,4.126,0,0,0,.1.9.584.584,0,0,0-.1.4c.1.9.4.5.5.9.2.9.5.7.5,1.2C3.5,10.9,3.1,11.3,1.9,11.7Z"
          transform="translate(0 -3)" fill={color}/>
    </>
    ]
  }
  getViewBox = () => '0 0 16 11'
}
